"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const EditCycleContext_1 = require("context/admin/EditCycleContext");
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const DividerCard_1 = __importDefault(require("components/shared/DividerCard"));
const ModalConfirmEditCycle = ({ submitEditCycle, closeModal, isLoading }) => {
    const { stateData } = (0, EditCycleContext_1.useEditCycle)();
    const getDescriptionTrack = (value) => {
        return (0, HelperUtils_1.getObjectiveLocale)(value
            ? "Reviewers can't switch between tracks before answering all questions"
            : "'Reviewers can switch freely between tracks even when questions have not been answered yet'");
    };
    return (react_1.default.createElement(Modal_1.default, { minWidth: 800, customClass: "!max-w-[800px] max-h-[600px]", onClose: closeModal },
        react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)('What Changes?'), titleIcon: {
                name: 'icon-warning',
                color: 'var(--y-600)'
            }, onClose: closeModal }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "px-[24px]" }, stateData.confirmData.map((data, index) => {
                const isLast = index === stateData.confirmData.length - 1;
                return (react_1.default.createElement(react_1.default.Fragment, { key: index },
                    data.id === 'name' && (react_1.default.createElement(DividerCard_1.default, { title: data?.titleSection, prev: stateData?.cycle?.[data?.id], current: stateData?.editedCycle?.[data?.id], isLast: isLast })),
                    data.id === 'restrictedTrackNavigation' && (react_1.default.createElement(DividerCard_1.default, { title: data?.titleSection, prev: getDescriptionTrack(stateData?.cycle?.[data?.id]), current: getDescriptionTrack(stateData?.editedCycle?.[data?.id]), isLast: isLast })),
                    data.id === 'reviewSchedule' && (react_1.default.createElement(DividerCard_1.default, { title: data?.titleSection, additionalColumn: data?.additionalColumn, prev: data?.prev, current: data?.current, warning: data?.warning, isLast: isLast }))));
            }))),
        react_1.default.createElement(Modal_1.default.Footer, { primaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Submit Changes'),
                onClick: submitEditCycle,
                isLoading: isLoading,
                dataCy: 'submit-config-cycle'
            }, secondaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Cancel'),
                onClick: closeModal,
                dataCy: 'cancel-config-cycle'
            }, useBorder: false })));
};
exports.default = ModalConfirmEditCycle;
